import React, { createContext, FC, useContext, useMemo, useReducer } from "react";

export interface State {
  displayPanel: boolean;
  panelView: string | null;
}

const initialState = {
  displayPanel: false,
  panelView: null,
  headerImage: null,
};

type Action =
  | {
    type: "OPEN_PANEL"
    view: string
    image: string | undefined
  }
  | {
    type: "CLOSE_PANEL"
  }

export const PanelRightContext = createContext<State | any>(initialState);
PanelRightContext.displayName = "PanelRightContext";

function panelRightReducer(state: State, action: Action) {
  switch (action.type) {
  case "OPEN_PANEL": {
    return {
      ...state,
      panelView: action.view,
      headerImage: action.image,
      displayPanel: true,
    };
  }
  case "CLOSE_PANEL": {
    return {
      ...state,
      panelView: null,
      headerImage: null,
      displayPanel: false,
    };
  }
  }
}

export const PanelRightProvider: FC = (props) => {
  const [state, dispatch] = useReducer(panelRightReducer, initialState);
  const openPanelRight = (view: string, image?: string) => dispatch({ type: "OPEN_PANEL", view, image });
  const closePanelRight = () => dispatch({ type: "CLOSE_PANEL" });

  const value = useMemo(
    () => ({
      ...state,
      openPanelRight,
      closePanelRight,
    }),
    [state],
  );

  return <PanelRightContext.Provider value={value} {...props} />;
};

export const usePanelRight = () => {
  const context = useContext(PanelRightContext);

  if (context === undefined) {
    throw new Error("useUI must be used within a UIProvider");
  }

  return context;
};
